export const VWC_VERSION = "4.1.0";
